var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCopy = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0736 1.59998H7.58134C6.45223 1.59997 5.55788 1.59996 4.85795 1.69444C4.13761 1.79168 3.55458 1.99655 3.09479 2.45819C2.63499 2.91983 2.43094 3.50521 2.33409 4.22843C2.23999 4.93118 2.24 5.82911 2.24001 6.96276V10.6988C2.24001 11.664 2.82878 12.4911 3.66539 12.8379C3.62233 12.2558 3.62237 11.4391 3.6224 10.7597L3.62241 7.61443L3.6224 7.55352C3.62236 6.73325 3.62232 6.0265 3.69811 5.46053C3.77933 4.85398 3.96249 4.27256 4.4322 3.80097C4.9019 3.32938 5.48099 3.14548 6.08511 3.06393C6.64882 2.98784 7.35275 2.98788 8.16974 2.98793L8.23041 2.98793H10.0736L10.1343 2.98793C10.9513 2.98788 11.6537 2.98784 12.2174 3.06393C11.8801 2.20656 11.0474 1.59998 10.0736 1.59998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54401 7.61443C4.54401 5.86967 4.54401 4.99729 5.08387 4.45526C5.62373 3.91323 6.49262 3.91323 8.23041 3.91323H10.0736C11.8114 3.91323 12.6803 3.91323 13.2201 4.45526C13.76 4.99729 13.76 5.86967 13.76 7.61443V10.6988C13.76 12.4435 13.76 13.3159 13.2201 13.8579C12.6803 14.4 11.8114 14.4 10.0736 14.4H8.23041C6.49262 14.4 5.62373 14.4 5.08387 13.8579C4.54401 13.3159 4.54401 12.4435 4.54401 10.6988V7.61443Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCopy, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Copy.e9b014cc.svg";
export { ForwardRef as ReactComponent };